import Component from './component';

Component.defaultProps = {
    children: null,
    className: '',
    error: false,
    errorMessage: null,
};

export default Component;